import api from './index';
//
let exports = {};

// ================================= 购置验收单 =====================

// 获取购置验收单分页列表
exports.getPurchReceiptList = function (data, callback) {
    api.post('/receipt/purch/receipt/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 获取购置验收单列表ByIds
exports.getPurchReceiptListByIds = function (data, callback) {
    api.post('/receipt/purch/receipt/list/get/by/ids')
    .data(data)
    .done(callback)
    .go();
};

// 获取购置验收单信息
exports.getPurchReceiptInfo = function (data, callback) {
    api.get('/receipt/purch/receipt/info/get')
    .params(data)
    .done(callback)
    .go();
};

// 保存购置验收单
exports.savePurchReceipt = function (data, callback) {
    api.post('/receipt/purch/receipt/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 待入账组装件保存购置验收单
exports.savePurchReceiptByAsmblAcc = function (data, callback) {
    api.post('/receipt/purch/receipt/save/do/by/asmblAcc')
    .data(data)
    .done(callback)
    .go();
};

// 购置验收单 - 业务冲销
exports.doPullBackPurchReceiptById = function (data, callback) {
    api.post('/receipt/purch/receipt/pullBack/do/by/id')
    .data(data)
    .done(callback)
    .go();
};
// 购置验收单业务冲销申请
exports.doApplyPurchReceiptPullBack = function (data, callback) {
    api.post('/receipt/purch/receipt/pullBack/apply/do')
    .data(data)
    .done(callback)
    .go();
};
// 购置验收单业务冲销审核
exports.doAuditPurchReceiptPullBack = function (data, callback) {
    api.post('/receipt/purch/receipt/pullBack/audit/do')
    .data(data)
    .done(callback)
    .go();
};
// 购置验收单审核
exports.doAuditPurchReceipt = function (data, callback) {
    api.post('/receipt/purch/receipt/audit/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getPurchReceiptMaxPrice = function (data, callback) {
    api.post('/receipt/purch/receipt/maxPrice/get')
    .data(data)
    .done(callback)
    .go();
};
// 购置验收单 - 作废
exports.doInvalidPurchReceiptById = function (data, callback) {
    api.post('/receipt/purch/receipt/invalid/do/by/id')
    .data(data)
    .done(callback)
    .go();
};
// 购置验收单 - 删除
exports.doDeletePurchReceiptById = function (data, callback) {
    api.post('/receipt/purch/receipt/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// 重新生成
exports.doCreatePurchReceipt = function (data, callback) {
    api.post('/receipt/purch/receipt/create/do')
    .data(data)
    .done(callback)
    .go();
};
// 重新推送
exports.doPurchReceiptPushOutSystem = function (data, callback) {
    api.post('/receipt/purch/receipt/push/outSystem')
    .data(data)
    .done(callback)
    .go();
};
// 重新执行
exports.doAfreshExecutePurchReceipt = function (data, callback) {
    api.post('/receipt/purch/receipt/afresh/execute/do')
    .data(data)
    .done(callback)
    .go();
};
// 验收商品项列表
exports.getPurchReceiptGoodsItemList = function (data, callback) {// 验收商品项列表
    api.post('/receipt/goods/item/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 保存临采验收单
exports.savePurchReceiptTemp = function (data, callback) {
    api.post('/receipt/purch/receipt/temp/save/do')
    .data(data)
    .done(callback)
    .go();
};

// ================================= 工单验收单 =====================
// 工单验收单分页列表
exports.getServcWorkReceiptList = function (data, callback) {
    api.post('/receipt/servc/work/receipt/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取工单验收单信息
exports.getServcWorkReceiptInfo = function (params, callback) {
    api.get('/receipt/servc/work/receipt/info/get')
    .params(params)
    .done(callback)
    .go();
};
// 保存工单验收单
exports.saveServcWorkReceipt = function (data, callback) {
    api.post('/receipt/servc/work/receipt/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 工单验收单确认
exports.doConfirmServcWorkReceipt = function (data, callback) {
    api.post('/receipt/servc/work/receipt/confirm/do')
    .data(data)
    .done(callback)
    .go();
};
// 工单验收单业务冲销
exports.doPullBackServcWorkReceipt = function (data, callback) {
    api.post('/receipt/servc/work/receipt/pullBack/do')
    .data(data)
    .done(callback)
    .go();
};
// 工单验收单业务冲销申请
exports.doApplyServcWorkReceiptPullBack = function (data, callback) {
    api.post('/receipt/servc/work/receipt/pullBack/apply/do')
    .data(data)
    .done(callback)
    .go();
};
// 工单验收单业务冲销审核
exports.doAuditServcWorkReceiptPullBack = function (data, callback) {
    api.post('/receipt/servc/work/receipt/pullBack/audit/do')
    .data(data)
    .done(callback)
    .go();
};
// 工单验收单作废
exports.doInvalidServcWorkReceiptById = function (data, callback) {
    api.post('/receipt/servc/work/receipt/invalid/do/by/id')
    .data(data)
    .done(callback)
    .go();
};
// 工单验收单删除
exports.doDeleteServcWorkReceiptById = function (data, callback) {
    api.post('/receipt/servc/work/receipt/delete/do/by/id')
    .data(data)
    .done(callback)
    .go();
};
// 工单验收单-工单无需结算
exports.updateServcWorkVoucherSettleFree = function (data, callback) {
    api.post('/receipt/servc/work/receipt/settleFree/update/do')
    .data(data)
    .done(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/receipt.js
// module id = 59
// module chunks = 0